import React, { useState, useEffect } from 'react';
import '../css/Memberships.css';
import line from '../images/underline.png';

import memberships from '../utils/memberships';
import Membership from './cards/Membership';

import Image from 'react-image-webp';
import image from '../images/award-background.png';
import imageWebp from '../images/award-background.webp';

import decoration from '../images/decorations/counseling_decoration_2.png';
import black from '../images/black.png';

const Memberships = () => {
	const [location, setLocation] = useState(null);

	useEffect(() => {
		const fetchLocation = async () => {
			try {
				const response = await fetch(`https://ipinfo.io/json?token=02e14e8acfee94`);
				const data = await response.json();
				// console.log(data);
				setLocation(data.country);
			} catch (error) {
				console.error('Error fetching the location:', error);
			}
		};
		fetchLocation();
	}, []);

	const membershipsList = memberships.map((training) => (
		<Membership key={training.id} membership={training} country={location} />
	));

	return (
		<section className='Memberships' id='entrenamientos'>
			<div className='memberships-container container padding'>
				<Image
					webp={imageWebp}
					src={image}
					alt='Memberships Background'
					className='memberships-image'
				/>
				<img src={decoration} alt='Membership Decoration' className='membership-decoration' />
				<div className='memberships-header'>
					<h1>
						INVERSIÓN DEL
						<br />
						<span>MÁSTER</span>
						<img className='convert-underline' src={line} alt='underline' />
					</h1>
				</div>

				{/* <div className='black-friday'> 
					<img  src={black} alt='black-friday' />
				</div> */}

				<div className='memberships-content'>{membershipsList}</div>
			</div>
		</section>
	);
};

export default Memberships;
